import React, { useEffect, useState } from 'react';
import styles from './DeviceCheck.module.css';
import qrcodeImage from '../../assets/images/qrcode.png';

const DeviceCheck: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);

  const checkDevice = () => {
    // 检查是否是移动设备
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    // 检查是否是竖屏
    const portrait = window.innerHeight > window.innerWidth;
    
    setIsMobile(mobile);
    setIsPortrait(portrait);
  };

  useEffect(() => {
    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  if (!isMobile) {
    return (
      <div className={styles.deviceWarning}>
        <div className={styles.content}>
          <h2>请使用手机访问</h2>
          <p>为了获得最佳体验，请使用手机扫描二维码访问本网站</p>
          <div className={styles.qrcode}>
            <img src={qrcodeImage} alt="访问二维码" />
          </div>
        </div>
      </div>
    );
  }

  if (!isPortrait) {
    return (
      <div className={styles.deviceWarning}>
        <div className={styles.content}>
          <h2>请竖屏使用</h2>
          <p>请将手机竖直放置，以获得最佳体验</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default DeviceCheck; 